/*
 * @Date: 2022-07-12 16:17:58
 * @LastEditTime: 2022-07-13 11:10:36
 * @FilePath: /vue-medweb/packages/vue-m-vaccine-prefecture/src/services/vaccineList.js
 * @Description: 疫苗列表相关接口
 */
import request from '@/utils/request';

// 获取有疫苗的城市
export const getHasVaccineLocations = params => {
  return request({
    method: 'GET',
    url: '/mall/vaccine/city_list/',
    params,
  });
};

// 获取疫苗专区疫苗列表页信息
export const getListInfo = params => {
  return request({
    method: 'GET',
    url: '/mall/vaccine/list_info/',
    params,
  });
};

// 获取疫苗列表
export const getVaccineList = params => {
  return request({
    method: 'GET',
    url: '/mall/vaccine/list/',
    params,
  });
};
